import React from 'react';
import { Alert } from 'reactstrap';

export const LinkInfo = ({ description, expiryDate }) => (
    <Alert color="info" className="mb-4">
        <div className="d-flex align-items-center">
            <i className="bx bx-info-circle me-2 fs-4" />
            <div>
                <strong>Ödeme Bağlantı Bilgileri:</strong><br />
                {description && <span>Açıklama: {description}<br /></span>}
                {expiryDate && <span>Son Geçerlik: {new Date(expiryDate).toLocaleString('tr-TR')}</span>}
            </div>
        </div>
    </Alert>
);

export const InvoiceInfo = ({ companyName, email, phone }) => (
    <Alert color="info" className="mb-4">
        <div className="d-flex align-items-center">
            <i className="bx bx-info-circle me-2 fs-4" />
            <div>
                <strong>Fatura Bilgileri:</strong><br />
                <span>Şirket: {companyName}<br /></span>
                <span>Email: {email}<br /></span>
                <span>Telefon: {phone}</span>
            </div>
        </div>
    </Alert>
);